"use client";

import { cn } from "@heroui/react";
import Image from "next/image";
import Link from "next/link";

export type LogoProps = {
  className?: string;
  justify?: "start" | "center" | "end";
  href?: string;
};

export default function Logo({ href, justify = "start" }: LogoProps) {
  return (
    <Link
      href={href || "/"}
      className="flex items-center gap-1 leading-none cursor-pointer !no-underline !text-black dark:!text-white w-full">
      <div className={cn(
        "flex flex-col text-xl font-logo font-bold w-full",
        justify === "start" && "items-start",
        justify === "center" && "items-center",
        justify === "end" && "items-end",
      )}>
        <div className="flex items-center w-full">
          <Image src="/assets/logo.svg" alt="vareselab.co" width={100} height={100} className="h-[30px] mr-px mb-[1px] w-auto" priority sizes="100px" />
          {/* <span className={cn(
            className,
            "text-xl tracking-wide font-logo font-bold leading-none",
          )}>
            VareseLab
          </span> */}

        </div>

      </div>
    </Link>
  );
}
